// extracted by mini-css-extract-plugin
export default {"container_page":"strong-intuition_container_page__rkcNK","text":"strong-intuition_text__dRZWh","couple_image":"strong-intuition_couple_image__7e2nt"};